// @inheritedComponent Accordion

import * as React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import withStyles from '@material-ui/core/styles/withStyles'
import ExpandMoreIcon from 'components/icons/ExpandMore'
import Accordion from 'components/Accordion'
import AccordionDetails from 'components/AccordionDetails'
import AccordionSummary from 'components/AccordionSummary'

export const styles = (theme) => ({
  root: {},
  disableGutters: {
    '--coa-toolbar-spacing': '0px',
  },
  summary: {},
  summaryContent: {
    ...theme.mixins.horizontalRhythm(1),
    ...theme.typography.subtitle1,
    alignItems: 'center',
  },
  icon: {
    marginRight: theme.spacing(1),
    transform: 'none !important',
  },
  details: {
    display: 'block',
    paddingBottom: theme.spacing(4),
  },
})

const ComposedAccordion = React.forwardRef(function ComposedAccordion(props, ref) {
  const {
    children,
    classes,
    className,
    disableGutters,
    expandIcon = <ExpandMoreIcon />,
    icon,
    summary,
    rotate = true,
    ...other
  } = props

  return (
    <Accordion
      className={clsx(
        classes.root,
        {
          [classes.disableGutters]: disableGutters,
        },
        className,
      )}
      ref={ref}
      {...other}
    >
      <AccordionSummary
        classes={{
          root: classes.summary,
          content: classes.summaryContent,
          expandIcon: !rotate && classes.icon,
        }}
        expandIcon={expandIcon}
      >
        {icon}
        <span>{summary}</span>
      </AccordionSummary>

      <AccordionDetails className={classes.details}>{children}</AccordionDetails>
    </Accordion>
  )
})

ComposedAccordion.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  disableGutters: PropTypes.bool,
  expandIcon: PropTypes.element,
  icon: PropTypes.element,
  summary: PropTypes.node.isRequired,
  rotate: PropTypes.bool,
}

export default withStyles(styles)(ComposedAccordion)
